import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { Divider } from 'primereact/divider';
import { useNavigate } from 'react-router-dom';
import styles from './ReportFailureDialog.styles.scss';
import cn from 'classnames';
import { getFailureTypeLabel } from '../../config/constants';
import { getAssetUrl } from '../../../../services/apis';
import { showToast } from '../../../../helpers/showToast';

const ReportFailureDialog = ({ isOpen, setIsOpen, onSubmit, failureType }) => {
  const navigate = useNavigate();

  let image;
  try {
    image = require('../../../../assets/png/tabler_file-description.png');
  } catch (e) {
    image = null;
  }

  const { t, i18n } = useTranslation();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [response, setResponse] = useState();

  const handleDownloadManual = async () => {
    setIsDownloading(true);
    try {
      const res = await getAssetUrl('raseed-user-manual-clean');
      const { url } = res.data;

      if (url) {
        window.open(url, '_blank');
      }
    } catch (error) {
      showToast({
        data: {
          type: 'error',
          message: t('failure_guidelines_failed'),
        },
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Dialog
      className={cn('rounded-4 overflow-hidden', styles.reportFailureDialog)}
      visible={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      header={
        !isSubmitted ? (
          <div className="d-flex flex-column w-100 gap-3">
            <h3>{t('failure_notification.important_instructions')}</h3>
            <Divider />
          </div>
        ) : (
          <div className={styles.imageDiv}>
            <div className={styles.imgDivBg}>
              {image ? (
                <img src={image} alt="" />
              ) : (
                <i className="pi pi-check" />
              )}
            </div>
          </div>
        )
      }
      footer={
        <>
          <Divider className="mb-4" />
          {isSubmitted ? (
            <Button
              onClick={() => {
                setIsOpen(false);
                navigate(
                  `/${i18n.language}/additional-functionalities/failure-notification`,
                );
              }}
              type="button"
              className="px-5 w-100"
              size="medium"
              label={t('common.home')}
            />
          ) : (
            <Button
              onClick={() => {
                setIsLoading(true);
                onSubmit()
                  .then(({ data }) => {
                    setResponse(data);
                    setIsSubmitted(true);
                  })
                  .catch(() => {
                    showToast({
                      data: {
                        variant: 'error',
                        text: t('common.general_error'),
                      },
                    });
                  })
                  .finally(() => {
                    setIsLoading(false);
                  });
              }}
              loading={isLoading}
              type="button"
              className="px-5 w-100"
              size="medium"
              label={t('common.submit')}
            />
          )}
        </>
      }
    >
      {!isSubmitted && (
        <div>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
            and scrambled it to
          </p>
          <ul className="px-4 my-3">
            {[1, 2, 3, 4, 5].map((k) => (
              <li key={k}>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </li>
            ))}
          </ul>
          <p>
            {t('failure_notification.more_information')}{' '}
            <Button
              link
              text
              className={cn('px-0 py-0', styles.download)}
              onClick={handleDownloadManual}
              disabled={isDownloading}
              label={t('common.here')}
            />
          </p>
        </div>
      )}
      {isSubmitted && (
        <div className={styles.submissionMessage}>
          <h2>{t('failure_notification.failure_reported_successfully')}</h2>
          <p>
            {t('failure_notification.reference_number_info', {
              number: response?.failureReferenceNumber,
            })}
          </p>
          <p>
            {t('failure_notification.failure_type')}: &nbsp;
            {getFailureTypeLabel({
              failureType,
              lang: i18n.language,
            })}
            .
          </p>
          <p>
            {t(
              'failure_notification.failure_resolved_successfully_instructions',
            )}
          </p>
        </div>
      )}
    </Dialog>
  );
};

export default React.memo(ReportFailureDialog);
